import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Col, Row, Link, Alert } from '@paypalcorp/pp-react';
import { get } from 'lodash';
import { links } from '../../../../constants/links.json';
import withTheme from '../../common/withTheme';
import { COUNTRY_CONFIG } from '../../../../constants/CountryConfig';

 class TermsContent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const pageData = JSON.parse(document.getElementById('data-pageData') && document.getElementById('data-pageData').innerHTML) || {};
        const countryCode = document.getElementsByTagName('html')[0].getAttribute('country');
        const agreementDate = pageData.dmLegalUpdateDate;
        const updatedPPFPPolicy = get(links, 'default.updatedPPFPPolicy', '');
        const agreementUpdateText = (this.props.propertyInfo && this.props.propertyInfo.directmodel.consent.agreementChange) ? this.props.propertyInfo.directmodel.consent.agreementChange.replace('{agreementDate}', agreementDate) : '';
        const DIRECTMODEL_COUNTRIES = Object.keys(COUNTRY_CONFIG).filter(country => COUNTRY_CONFIG[country].directModel);
        const filterLATAM = DIRECTMODEL_COUNTRIES.filter(item => ['BR', 'MX'].includes(item));
        const latamCountry = filterLATAM.includes(countryCode);
        return (
            <React.Fragment>
                {latamCountry &&
                        <Alert type="warning">
                            {ReactHtmlParser(agreementUpdateText)}
                            <Link href={updatedPPFPPolicy} target="_blank" data-fpti="legalUpdate">{get(this.props.propertyInfo, 'directmodel.consent.whatischanging')}</Link>
                        </Alert>
                }
                {this.props.flow === 'enrollment' &&
                    <Row>
                        <Col className="consentStmt"> {get(this.props.propertyInfo, 'directmodel.consent.header')}</Col>
                    </Row>
                }
                <Row>
                    <Col>
                        <div className="consentStmt">
                            <h4>{get(this.props.propertyInfo, 'directmodel.consent.note1')}</h4>
                            <p>{get(this.props.propertyInfo, 'directmodel.consent.subnote')}</p>
                            <ul className="agreement">
                                <li>{get(this.props.propertyInfo, 'directmodel.consent.note1a')}</li>
                                <li>{ReactHtmlParser(get(this.props.propertyInfo, 'directmodel.consent.note1b'))}</li>
                                <li>{get(this.props.propertyInfo, 'directmodel.consent.note1c')}</li>
                                <li>{get(this.props.propertyInfo, 'directmodel.consent.note1d')}</li>
                                <li>{get(this.props.propertyInfo, 'directmodel.consent.note1e')}</li>
                                <li>{ReactHtmlParser(get(this.props.propertyInfo, 'directmodel.consent.note1f'))}</li>
                            </ul>
                            <p>{get(this.props.propertyInfo, 'directmodel.consent.bottomnote1')}</p>
                            <h4>{get(this.props.propertyInfo, 'directmodel.consent.note2')}</h4>
                            <ul className="agreement">
                                <li>{get(this.props.propertyInfo, 'directmodel.consent.note2a')}</li>
                                <li>{get(this.props.propertyInfo, 'directmodel.consent.note2b')}</li>
                                <li>{ReactHtmlParser(get(this.props.propertyInfo, 'directmodel.consent.note2c'))}</li>
                            </ul>
                            <p>{get(this.props.propertyInfo, 'directmodel.consent.bottomnote2')}</p>
                            <h4>{get(this.props.propertyInfo, 'directmodel.consent.note3')}</h4>
                            <ul className="agreement">
                                <li>{get(this.props.propertyInfo, 'directmodel.consent.note3a')}</li>
                            </ul>
                            <p>{get(this.props.propertyInfo, 'directmodel.consent.bottomnote3')}</p>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}
export default withTheme(TermsContent);